import React from 'react';
import './Services.css';
import { 
  FaLaptopCode, 
  FaCogs, 
  FaHeadset, 
  FaShieldAlt,
  FaNetworkWired,
  FaCloud,
  FaServer,
  FaProjectDiagram,
  FaLightbulb
} from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      title: "Digitalização de Processos",
      icon: <FaLightbulb />,
      description: "Transforme tarefas manuais em fluxos de trabalho inteligentes.",
      details: (<> A Infosfera digitaliza e automatiza processos com <strong>qualidade e precisão,</strong> reduzindo custos e aumentando a eficiência — sempre com <strong>responsabilidade e segurança</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
           </> )
      },
    {
      title: "Desenvolvimento de Software sob Medida",
      icon: <FaLaptopCode />,
      description: "Soluções que falam a língua do seu negócio.",
      details:(<> Criamos aplicações personalizadas para atender às suas necessidades específicas, garantindo <strong>qualidade no código, confiabilidade no desempenho e resultados que superam expectativas</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
     </> ) 
    },
    {
      title: "Consultoria em TI",
      icon: <FaHeadset />,
      description: "Estratégia e tecnologia lado a lado.",
      details: (<> Oferecemos análises, recomendações e planos personalizados para impulsionar o crescimento da sua empresa com <strong>responsabilidade técnica e soluções confiáveis.</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
        </> ) 
    },
    {
      title: "Cibersegurança",
      icon: <FaShieldAlt />,
      description: "A sua informação, protegida 24/7.",
      details:(<> Implementamos políticas e tecnologias que blindam os seus dados contra ameaças, garantindo <strong>confiança, conformidade e tranquilidade para o seu negócio</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> )  
    
      },
    {
      title: "Suporte e Manutenção Especializados",
      icon: <FaCogs />,
      description: "Mais do que suporte, parceria contínua.",
      details: (<> Mantemos a sua infraestrutura sempre atualizada e funcional, com atendimento rápido e eficaz, priorizando <strong>qualidade, responsabilidade e satisfação do cliente</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> ) 
      },
    {
      title: "Desenho e Implementação de Projetos Informáticos",
      icon: <FaProjectDiagram />,
      description: "Do papel à realidade, com excelência.",
      details: (<> Planeamos e executamos projetos de TI de ponta a ponta, com <strong>rigor técnico, prazos cumpridos e resultados confiáveis</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> ) 
      },
    {
      title: "Computação em Nuvem",
      icon: <FaCloud />,
      description: "Flexibilidade e segurança para o seu negócio.",
      details: (<> Migramos e gerimos os seus serviços na nuvem, oferecendo <strong>acesso seguro, alta disponibilidade e total confiabilidade.</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> ) 
      },
    {
      title: "Virtualização",
      icon: <FaServer />,
      description: "Mais eficiência, menos custos.",
      details:  (<> Consolidamos servidores e ambientes virtuais para otimizar recursos, reduzir gastos e garantir <strong>desempenho confiável com máxima segurança.</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
   </> )
      },
    {
      title: "Infraestrutura de Rede e Conectividade",
      icon: <FaNetworkWired />,
      description: "A base sólida para a sua transformação digital.",
      details: (<> Projetamos, instalamos e otimizamos redes de computadores com cablagem estruturada de alta qualidade, garantindo conexões seguras, estáveis e de alto desempenho. Cada projeto é executado com responsabilidade técnica, rigor nos prazos e foco total na confiança e satisfação do cliente — desde a infraestrutura física até à configuração e manutenção da rede. <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> )
      }
  ];

  return (
    <div id="servicos-section" className="services-container">
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-name">{service.title}</h3>
            <p className="service-description">{service.description}</p>
            <p className="service-details">{service.details}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;